// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconGraduationHat = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M3 9.57V15H1V6.96l10.656-3.9h.688l10.66 3.9v1.88l-5.03 1.84A7.97 7.97 0 0120 16v2l-.725.962-7 2h-.55l-7-2L4 18v-2a7.97 7.97 0 012.027-5.322zm5.103 1.868A5.99 5.99 0 006 16v1.246l6 1.714 6-1.714V16a5.99 5.99 0 00-2.102-4.562l-3.554 1.3h-.688zM12 10.734L4.254 7.9 12 5.065l7.75 2.834z"
    />
  );
export default SvgIconGraduationHat;
